export default __webpack_public_path__ + "static/media/Path3392.c354b70a.svg";